import { render, staticRenderFns } from "./FileUploadProperties.vue?vue&type=template&id=83ae8484"
import script from "./FileUploadProperties.vue?vue&type=script&lang=js"
export * from "./FileUploadProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports